/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
export default {
  typesOfMin: {
    minimums: 'minimums',
    ifr: 'ifr',
    warning: 'warning',
  },
  minimumsList: [{
    id: 1,
    displayText: 'Ceilings',
    isEnabled: false,
    type: 'minimums',
    inputType: 'number',
    defaultValue: 1800,
    personalValue: null,
  }, {
    id: 2,
    displayText: 'Visibility',
    isEnabled: false,
    type: 'minimums',
    inputType: 'number',
    defaultValue: 10,
    personalValue: null,
  }, {
    id: 3,
    displayText: 'Gust',
    isEnabled: false,
    type: 'minimums',
    inputType: 'number',
    defaultValue: 20,
    personalValue: null,
  }, {
    id: 4,
    displayText: 'Crosswind',
    isEnabled: false,
    type: 'minimums',
    inputType: 'number',
    defaultValue: 12,
    personalValue: null,
  }, {
    id: 5,
    displayText: 'Temperature',
    isEnabled: false,
    type: 'minimums',
    inputType: 'number',
    defaultValue: 120,
    personalValue: null,
  }, {
    id: 6,
    displayText: 'Warning Item',
    isEnabled: false,
    type: 'warning',
    inputType: 'text',
    defaultValue: 'Fire',
    personalValue: null,
  }],
};
